import React from 'react';
import PropTypes from 'prop-types';
import Typography from '../../../../components/Typography/Typography';
import Grid from '../../../../components/Grid/Grid';

const CreatePilotTransferError = ({ errorMessage }) => (
  <Grid container direction="column" gap={0.5} sx={{ py: 1 }}>
    <Typography variant="subtitle1">{errorMessage}</Typography>
  </Grid>
);

CreatePilotTransferError.propTypes = {
  errorMessage: PropTypes.string.isRequired,
};

export default CreatePilotTransferError;
